import React, { useEffect } from 'react';

import { ClientStaffMessageLog, ViewMessageLogModal } from '../EntityList/ViewMessageLog';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import ClientStaffDetail from '../Editors/ClientStaffDetail';
import CharterRequest from '../EntityList/CharterRequestsSupplier'
import { useFormikContext } from 'formik';
import ClientModal from '../Models/ClientModal';
import { useAuth } from '../../Services/AuthContext';
import MarginDetails from '../Editors/MarginDetails';
import TimeLine from '../EntityList/TimeLine';
const ClientStaffEditor = ({ edit, item, route ,entity,isNewItem }) => {
    const params = useParams();
    const { clientStaffId, staffAction } = params;
    const { values } = useFormikContext();
    const [auth] = useAuth()
    const { push } = useHistory();
    const { id } = values; 
     useEffect(() => {
        if (edit) {
            push(route + '/' + clientStaffId + '/Detail');
        }
    }, [edit,clientStaffId,route,push]);
    

    const itemParam = staffAction === 'Staff' ? 'clientDepartmentId' : staffAction === 'Department' ? 'clientStaffId' : 'messageId';
   
    const setKey = (tab) => {
        push(route + '/' + clientStaffId + '/' + tab);
    }
    const differentRoute = staffAction !== 'Margin' && staffAction !== 'Messsages' && staffAction !== 'Charters';
    return <Tabs activeKey={staffAction} style={{ height: '100%' }} onSelect={setKey}>
        <Tab key={'Detail'} eventKey={'Detail'} title='Detail' >
            {!staffAction || differentRoute || staffAction === 'Detail' ? <ClientStaffDetail route={route + '/' + id + '/Detail' } invite={isNewItem} item={{ ...values, department: item }} edit={edit} /> : null}
        </Tab>
        {!edit && <Tab key={'Charters'}  eventKey={'Charters'} title='Charters' style={{ height: '600px' }} >
            {staffAction === 'Charters' ? <CharterRequest item={{ ...values, department: item }} area='staff' route={route + '/' + clientStaffId + '/' + staffAction} parentHeight={550} /> : null}
        </Tab>}
        {auth && auth.role === 'Admin' && !edit && <Tab key={'Margin'} eventKey={'Margin'} title='Margin' style={{ height: '400px' }} >
            {staffAction === 'Margin' ? <MarginDetails  id={id} route={route + '/' + id + '/' + staffAction} item={values} parentHeight={400} /> : null}
        </Tab>}
        {!edit && <Tab key={'Messages'} eventKey={'Messages'} title='Messages' style={{ height: '400px' }} >
            {staffAction === 'Messages' ? <ClientStaffMessageLog item={{ ...values, department: item }} itemParam={itemParam} route={route + '/' + clientStaffId + '/' + staffAction} parentHeight={400} /> : null}
        </Tab>
        }
                 {!edit && <Tab key={'Timeline'} eventKey={'Timeline'} title='Timeline' style={{ height: '400px' }} >
            {staffAction === 'Timeline' ? <TimeLine charterRequestCol supplierCol type={"ClientStaff"} item={values} route={route + '/' + id + "/Timeline"} parentHeight={400} headerHeight={0} /> : null}
        </Tab>
        }
        
        <Switch>
            
            <Route path={route + '/' + clientStaffId + '/Messages/:messageId'} render={() => <ViewMessageLogModal />}/>
            <Route path={route + '/' + clientStaffId + '/Charters/:list/:activeKey/:charterRequestId'} render={() => <ClientModal route={route} entity={entity} itemParam='charterRequestId' > <CharterRequest entity={entity} route={route} /></ClientModal>}/>
           

        </Switch>
    </Tabs >
}
export default ClientStaffEditor;